module.exports = __webpack_public_path__ + "img/bulb_off@2x.01349dbc.png";